import React, { ChangeEvent } from "react";
import { Key } from "./types";

interface KeyTableProps {
  keys: Key[];
  handleRemoveKeyx: (id: number) => void;
  handleKeyChange: (index: number, field: keyof Key, value: number | string) => void;
  backendUrl: string;
}

const KeyTable: React.FC<KeyTableProps> = ({ keys, handleRemoveKeyx, handleKeyChange, backendUrl }) => {
  return (
    <div className="key-table">
      {keys.map((el, index) => (
        <div key={index} className="key-table-row">
          <img
            src={`${backendUrl}/img/XRed.svg`}
            alt="X"
            style={{
              width: "20px",
              height: "20px",
              cursor: "pointer",
              padding: "4px",
            }}
            onClick={() => handleRemoveKeyx(Number(el.id))}
          />
          <input
            type="number"
            className="inputCenter"
            placeholder=""
            value={el.amount}
            onChange={(e: ChangeEvent<HTMLInputElement>) =>
              handleKeyChange(
                index,
                "amount",
                parseInt(e.target.value, 10)
              )
            }
          />

          <input
            type="text"
            value={el.keyName}
            onChange={(e: ChangeEvent<HTMLInputElement>) =>
              handleKeyChange(index, "keyName", e.target.value)
            }
          />
        </div>
      ))}
    </div>
  );
};

export default KeyTable;
